import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const reasons = ['Fácil de implementar.', 'Actividades listas para usar.', 'Diseñado para niños de 3 a 10 años.', 'Aprendizaje mediante el juego.', 'Ideal para el hogar y la escuela.', 'Material imprimible.'];
export function WhyChooseSection() {
  return <section className="py-20 bg-pastel-lilacLight/30" data-id="element-273">
      <div className="container mx-auto px-6 max-w-5xl" data-id="element-274">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-275">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-800 mb-4" data-id="element-276">
            ¿Por qué tantas familias lo están eligiendo?
          </h2>
          <div className="w-24 h-1.5 bg-pastel-yellow mx-auto rounded-full" data-id="element-277"></div>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-278">
          {reasons.map((reason, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-2xl p-6 shadow-sm border border-slate-100 flex flex-col items-center text-center gap-4 hover:shadow-md transition-shadow" data-id="element-279">
              <div className="w-12 h-12 bg-pastel-yellowLight rounded-full flex items-center justify-center" data-id="element-280">
                <Star className="w-6 h-6 text-yellow-500 fill-yellow-500" data-id="element-281" />
              </div>
              <p className="text-lg font-bold text-slate-700" data-id="element-282">{reason}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}